import styled from 'styled-components'
import {
  Frame,
  FrameHeader,
  FrameContent,
  typography,
  spacing,
  DisplaySmall,
  BodyLarge,
  color,
  hslaConverter
} from '@conserveit/blocks'

/** Outermost wrapper for the charts side */
export const Container = styled.div`
  flex-grow: 1;
`

/** Outermost block for the main chart widget, styled Frame block */
export const Block = styled(Frame)`
  margin-bottom: ${spacing.extraLoose};
  overflow: hidden;
`

export const Content = styled(FrameContent)`
  min-height: 100px;
`

export const GridContainer = styled.div`
  padding: 0 ${spacing.default} ${spacing.default};
  max-height: 500px;
  overflow: auto;
`

/** Styled FrameHeader, wraps the heading and controls */
export const Header = styled(FrameHeader)`
  ${typography.displaySmall};
  display: flex;
  align-items: center;
  border-bottom: none;
  padding-bottom: 0;
`

/** Wraps both the title and subtitle */
export const Heading = styled.div`
  flex-grow: 1;
`

/** Wraps chart controls, pushed to the far right */
export const Controls = styled.div``

/** Main title of the header, h3 by default */
export const Title = styled(DisplaySmall)`
  em {
    font-style: italic;
  }
`

/** Typically a description of the chart information, shown below the Title */
export const Subtitle = styled(BodyLarge)`
  color: ${hslaConverter(color.theme.typography.subdued, 'hex')};
`
